export default __webpack_public_path__ + "static/9-9dc4574fd4f23e6fc577e2692c91382f.jpg";